/**
 * Integration module constants
 * Centralizes all hardcoded values for better maintainability and type safety
 */

export enum PartnerName {
  LIGHTSPEED = 'LIGHTSPEED',
  SHIPDAY = 'SHIPDAY'
}

export const PARTNER_SLUGS = {
  LIGHTSPEED: 'lightspeed-pos',
  SHIPDAY: 'shipday'
} as const

export const PARTNER_DISPLAY_NAMES = {
  LIGHTSPEED: 'Lightspeed',
  SHIPDAY: 'Shipday'
} as const

export const INTEGRATION_CATEGORIES = {
  POS: 'POS',
  DELIVERY: 'Delivery'
} as const

export type PartnerNameType = keyof typeof PartnerName
export type PartnerSlug = (typeof PARTNER_SLUGS)[keyof typeof PARTNER_SLUGS]

/**
 * Helper to get partner name in lowercase (for API comparisons)
 */
export const getPartnerNameLowercase = (partnerName: PartnerName): string => {
  return partnerName.toLowerCase()
}

/**
 * Helper to check if a partner name matches
 */
export const isPartner = (name: string, partner: PartnerName): boolean => {
  return name.toLowerCase() === partner.toLowerCase()
}

export const SHIPDAY_APP_URL =
  'https://dispatch.shipday.com/dashboard#integrations'
export const SHIPDAY_SIGNUP_URL =
  'https://dispatch.shipday.com/signUp/Uxz6fVxLkO'
export const SHIPDAY_HELP_URL =
  'https://support.slerp.com/knowledge/shipday-integration'
